// store.ts
import { useStorage, useDateFormat, createGlobalState } from '@vueuse/core';
import {
  shallowRef,
  computed,
  readonly,
  reactive,
  ref,
  shallowReactive,
  shallowReadonly,
} from 'vue';
import { UAParser } from 'ua-parser-js';
const parser = new UAParser();
import { useCookies } from '@vueuse/integrations/useCookies';
import Storage from '@/utils/storage';
const lazy_image = useStorage('supportLazyImage', '');

const TEAM = import.meta.env.VITE_TEAM

// 判断是否支持懒加载
if (!lazy_image.value) {
  let testImg = document.createElement('img');
  if ('loading' in testImg) {
    lazy_image.value = 'true';
  } else {
    lazy_image.value = 'false';
  }
}

const storage = new Storage()

// 每次活动都会用到的状态
export const useStore = createGlobalState(() => {



  // 浏览器设备信息
  const uaResult = parser.getResult();
  const ua_info = {
    browser: {
      name: uaResult.browser.name,
      version: uaResult.browser.version,
      major: uaResult.browser.major,
    },
    os: {
      name: uaResult.os.name,
      version: uaResult.os.version,
    },
    device: {
      model: uaResult.device.model,
      type: uaResult.device.type, // 'mobile', 'tablet', 'desktop', 'tv', etc.
      vendor: uaResult.device.vendor,
    },
    engine: {
      name: uaResult.engine.name,
      version: uaResult.engine.version,
    },
    cpu: {
      architecture: uaResult.cpu.architecture,
    },
    userAgent: navigator.userAgent,
  };

  const is_mobile = computed(() => {
    return uaResult.device.type === 'mobile' ? true : false;
  });
  
  // 渠道标识
  const channel = shallowReactive({
    utm_source: 'gw',
    extra: 'gw',
    channel: uaResult.device.type === 'mobile' ? 'mobile' : 'pc',
  });
  
  function set_utm_source(v) {
    channel.utm_source = v;
  }

  const group = computed(() => {
    return TEAM
  })

  const browser = shallowRef(parser.getBrowser().name);
  // 是否支持图片懒加载
  const support_lazy_image = shallowRef(lazy_image.value);

  // 支持的图片格式
  const support_image = useStorage('supportImg', 'png');

  // 门派
  const schools = ref({});
  const set_schools = (v) => {
    schools.value = v;
  }

  // 地区
  const sectors = ref({});
  const set_sectors = (v) => {
    sectors.value = v;
  }

  // 排行榜类别
  const rank_type = ref([]);
  const set_rank_type = (v) => {
    rank_type.value = v;
  }


  // 各种跳转链接
  const urls = ref({});
  const set_urls = (v) => {
    urls.value = v;
  }



  return {
    channel: readonly(channel),
    ua_info,
    support_lazy_image: shallowReadonly(support_lazy_image),
    set_utm_source,
    browser: shallowReadonly(browser),
    is_mobile: readonly(is_mobile),
    support_image: readonly(support_image),

    group: readonly(group),

    schools: shallowReadonly(schools),
    set_schools,
    sectors: shallowReadonly(sectors),
    set_sectors,
    rank_type: shallowReadonly(rank_type),
    set_rank_type,

    urls: shallowReadonly(urls),
    set_urls,
  };
});

// 单次活动需要定义的全局变量:这里是每次都变的
export const useData = createGlobalState(() => {

  

  // 搜索记录缓存
  const search_record_key = `${TEAM}_search`
  const search_record = ref(storage.getItem(search_record_key) || [])

  // console.log('search_record', search_record.value)
  function set_search_record(v) {
    const save_len = 20
    const index = search_record.value.indexOf(v)
    if (index > -1) {
      search_record.value.splice(index, 1)
    }
    search_record.value.unshift(v)
    storage.setItem({ 'name': search_record_key, 'value': search_record.value.slice(0, save_len) })
    console.log('set_search_record', search_record.value)
  }



  return {
    search_record,
    set_search_record,
  };
});


// 每次活动都会用到的状态
export const Game = createGlobalState(() => {
  // 属性： 力、体、敏、疾、魂、念
  const attr = shallowReactive([
    { 'text': '力', 'key': 'str' },
    { 'text': '体', 'key': 'con' },
    { 'text': '敏', 'key': 'dex' },
    { 'text': '疾', 'key': 'dog' },
    { 'text': '魂', 'key': 'int' },
    { 'text': '念', 'key': 'mind' },
  ]);

  return {
    attr,
  }

})